export default function HeroSection() {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/98a480da2a8661dbc139108d767b92d7.jpg"
          alt="Students"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 text-center text-white px-6 w-full">
        <p className="text-sm mb-6 tracking-widest">NIJIHASHI CORPORATION</p>
        <h1 className="text-6xl md:text-7xl font-light mb-8 leading-tight" style={{ fontFamily: 'serif' }}>
          学生一人ひとりの<br />
          未来を虹のように輝かせる
        </h1>
        <p className="text-lg md:text-xl mb-12 max-w-2xl mx-auto font-light">
          2019年設立。大学進学支援、学生生活サポート、寮管理を通じて<br />
          学生の夢と目標の実現を全力で支援します
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
          <a
            href="#services"
            className="bg-sky-500 text-white px-8 py-4 rounded-lg text-base hover:bg-sky-400 transition-all flex items-center space-x-2 whitespace-nowrap cursor-pointer"
          >
            <span>サービス紹介</span>
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="/downloads"
            className="bg-white text-sky-600 px-8 py-4 rounded-lg text-base hover:bg-sky-50 transition-all flex items-center space-x-2 whitespace-nowrap cursor-pointer font-medium"
          >
            <i className="ri-download-2-line"></i>
            <span>資料ダウンロード</span>
          </a>
          <a
            href="/contact"
            className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg text-base hover:bg-white/20 transition-all border border-white/30 whitespace-nowrap cursor-pointer"
          >
            お問い合わせ
          </a>
        </div>
      </div>

      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
}
